export default __webpack_public_path__ + "static/media/icon1.a1f3e25e.svg";